import React, { useEffect } from "react";
import DOMPurify from "dompurify";

/**
 * Raw HTML
 */
function RawHtml(props: { html: string }) {
  const cleanHtml = DOMPurify.sanitize(props.html);

  const ref = React.createRef<HTMLDivElement>();
  useEffect(() => {
    if (ref) {
      ref.current && ref.current.scrollTo({ top: 0 });
    }
  }, [ref]);
  return (
    <div
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
      ref={ref}
      className="max-h-[70vh] overflow-auto [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:mb-4 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-6 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-4 [&_h3]:mb-2 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3 [&_li]:mb-1"
    />
  );
}

export default RawHtml;
